// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__hObYD","total":"Cart_total__dkSUi","actions":"Cart_actions__ukV3G","button--alt":"Cart_button--alt__NowFg","button":"Cart_button__10fpS"};